<template>
  <div id="app">
    <router-view />
    <loading :active.sync="isLoading"
             :can-cancel="false"
             loader="dots"
             :is-full-page="true">
    </loading>
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import Loading from 'vue-loading-overlay';

  export default {
    name: 'App',
    components: {
      Loading
    },
    computed: {
      ...mapGetters([
        "isLoading"
      ])
    },
    methods: {
      ...mapActions([
        'initData'
      ])
    },
    created () {
      //this.initData()
    }
  }
</script>